import {FormControl, Grid, TextField} from '@material-ui/core';
import moment from 'moment';
import React, {useEffect, useMemo, useState} from 'react';
import {useQueryClient} from "react-query";

import {CheckboxEditor, ComboSelect, DatePicker, FormDialog, MaskedTime,} from "../../../controls";
import { useAddHandoverItem, useUpdateHandoverItem } from '../../../services/flights';
import Validator from "../validators/HandoverItemDialogValidator";

const HandoverDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    title: 'Handover Item',
    record: null
  });

  const DisplayForm = () => {
    const extraKeys = [];
    const handleAddHandoverItem = useAddHandoverItem();
    const handleUpdateHandoverItem = useUpdateHandoverItem();

    return (
      <FormDialog
        title={dialogState.title}
        message=""
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{maxWidth: "md", fullWidth: true}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Update", label: dialogState.record?.handoverUuid ? "Update" : "Add", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            const saveRecord = (record) => {
              if (record.handoverUuid) {
                handleUpdateHandoverItem.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({ ...dialogState, showDialog: false, record: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Handover Item", "An unexpected error has occurred while saving the handover item.");
                  }
                });
              } else {
                handleAddHandoverItem.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({ ...dialogState, showDialog: false, record: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Handover Item", "An unexpected error has occurred while saving the handover item.");
                  }
                });
              }
            }
            saveRecord(record);
          } else {
            setDialogState({...dialogState, showDialog: false, record: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3} >{/*style={{width: "calc(100% + 36px"}}*/}
          <Grid item xs={4} checkChildren={true}>
            {(record) => (
              <FormControl checkChildren={true} style={{display: "block"}}>
                <ComboSelect
                  id="category"
                  label="Category"
                  group="HANDOVER CATEGORIES"
                  subGroup=""
                  readOnly={!dialogState.canEdit}
                  fullWidth
                />
              </FormControl>
            )}
          </Grid>
          <Grid item xs={4} checkChildren={true}>
            {(record) => (
              <FormControl checkChildren={true} style={{display: "block"}}>
                <ComboSelect
                  id="priority"
                  label="Priority"
                  group="HANDOVER PRIORITIES"
                  subGroup=""
                  readOnly={!dialogState.canEdit}
                  fullWidth
                />
              </FormControl>
            )}
          </Grid>
          <Grid item xs={4} checkChildren={true}>
            {(record) => (
              <div style={{marginTop: 15}}>
                <div style={{position: "relative", display: "inline-block", width: "65%"}}>
                  <DatePicker
                    id="targetCompletion"
                    label="Target Completion"
                    autoOk={true}
                    value={record.targetCompletion}
                    minDate={dialogState.minDate}
                    inputLabelProps={{ shrink: true }}
                    readOnly={!dialogState.canEdit}
                    onChange={(value, props) => {
                      debugger;
                      const targetMoment = moment(record.delayedUntil);
                      const newDate = moment.utc(value).startOf('day');
                      const hh = targetMoment.get('hour');
                      const mm = targetMoment.get('minute');
                      const delayedUntil = moment(newDate).set('hour', hh).set('minute', mm);
                      if (delayedUntil.isValid()) {
                        props.recordChange({...props.record, targetCompletion: delayedUntil.toISOString(true)})
                      } else {
                        props.onChange(value);
                      }
                    }}
                  />
                </div>
                <div style={{position: "relative", display: "inline-block", width: "calc(35% - 5px)", paddingLeft: 5, top: -6.5}}>
                  <MaskedTime
                    id="delayedUntil"
                    label=" "
                    value={record.delayedUntil}
                    source="timestamp"
                    inputLabelProps={{ shrink: true }}
                    readOnly={!dialogState.canEdit}
                    onChange={(value, props) => {
                      let delayedUntil = moment(value);
                      if (value.length === 19 && delayedUntil.isValid()) {
                        const hh = delayedUntil.get('hour');
                        const mm = delayedUntil.get('minute');
                        delayedUntil = moment.utc(props.record.targetCompletion).set('hour', hh).set('minute', mm);
                        props.recordChange({...props.record, targetCompletion: delayedUntil.toISOString(), delayedUntil: value})
                      }
                    }}
                  />
                </div>
              </div>
            )}
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} checkChildren={true}>
            <TextField
              id="detail"
              label="Details"
              InputLabelProps={{ shrink: true }}
              placeholder="Handover items details"
              multiline
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} />
          {(record) => record.handoverUuid
            ?
              <Grid item xs={12} checkChildren={true}>
                <CheckboxEditor
                  id="completed"
                  label="Completed"
                  readOnly={!dialogState.canEdit}
                  onChange={(value, props) => {
                    if (value === false) {
                      props.recordChange({...props.record, completed: false})
                    } else {
                      props.recordChange({...props.record, completed: true})}
                  }}
                />
              </Grid>
            :
              <></>
          }
        </Grid>
      </FormDialog>
    );
  }

  useEffect(()=> {
    const open = async (params) => {
      const {title, canEdit, record} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, record, minDate: moment().startOf('day')});
    }
    eventBus.bind("HandoverItemDialog.open", open);

    return () => {
      eventBus.unbind("HandoverItemDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog && dialogState.record) {
    return (<DisplayForm />);
  }
  return (<></>);
}

export default HandoverDialog;
